import { createSlice } from '@reduxjs/toolkit'
import { styleDefaults } from 'apps/studio/lib/utils/styles'
import { updateOnSave } from 'apps/formsCreationKit/store/actions/sharedActions'
import { saveApp } from 'apps/formsCreationKit/store/reducers/settings/appSettings'
import { addPdf, resetPdf } from 'apps/studio/store/actions/sharedActions'

export const DEFAULT_WIDTH = 150
export const DEFAULT_HEIGHT = 50

export const initialState = {
  id: null,
  pdf_path: null,
  form_id: null,
  styles: styleDefaults,
  position: {
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT,
  },
}

// TODO: This may be better handled at the input level, but
// for now we're just ensuring that the position values are numbers.
export const ensureNumber = update => {
  let numberUpdates = {}
  Object.keys(update).forEach(key => {
    numberUpdates[key] = Number(update[key])
  })
  return numberUpdates
}

export const pdfSlice = createSlice({
  name: 'pdf',
  initialState,
  reducers: {
    updateGlobalStyles(state, action) {
      return {
        ...state,
        styles: {
          ...state.styles,
          ...action.payload,
        },
      }
    },
    updateGlobalPosition(state, action) {
      return {
        ...state,
        position: {
          ...state.position,
          ...ensureNumber(action.payload),
        },
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(addPdf, (state, action) => {
      // TODO: We may ultimately want this as a thunk that uploads the PDF and
      // returns the hosted URL.
      const { pdf_path } = action.payload
      return {
        ...initialState,
        form_id: state.form_id,
        pdf_path,
      }
    })
    builder.addCase(resetPdf, (state, action) => {
      const { deletePdf = false } = action.payload || {}
      // Clear PDF and reset to initial state when user clicks "Start Over"
      if (deletePdf) {
        return initialState
      }
      // Keep PDF and reset styles when the user clicks "Reset"
      return {
        ...state,
        styles: styleDefaults,
        position: {
          width: DEFAULT_WIDTH,
          height: DEFAULT_HEIGHT,
        },
      }
    })
    builder.addCase(updateOnSave, (state, action) => {
      const { id: form_id } = action.payload
      return {
        ...state,
        form_id,
      }
    })
    builder.addCase(saveApp.fulfilled, (state, action) => {
      const { pdf } = action.payload
      const { id } = pdf || {}
      return {
        ...state,
        id,
      }
    })
  },
})

const { actions, reducer } = pdfSlice
export const pdfActions = actions
export const pdfReducer = reducer
